import styled from "@emotion/styled";
export const StyledProductPrice = styled.div`
  height: ${({ isNewPricing })=>isNewPricing ? '120px' : '140px'};

  .price-tag {
    margin: 8px 0 8px 0;
    display: flex;
    justify-content: flex-start;
    align-items: flex-end;

    .amount {
      font-size: 2.7rem;
      margin-right: 4px;
      font-weight: 600;
    }

    .price-description {
      line-height: 18px;
      font-size: 0.8125rem;
      color: #323338;
      margin-bottom: 4px;
    }
  }

  .discount-chip {
    font-size: 12px;
    font-weight: 400;
    margin-left: 8px;
    color: #006278;
    background-color: #E7F4F6;
    padding: 2px 8px;
    border-radius: 4px;
  }

  .price-currency-text {
      font-size: 8px;
      font-weight: bold;
      margin-left: 4px;
  }
  .product-price-total-wrapper {
    display: flex;
    gap: 5px;
  }

  .product-price-billed-periodically {
    font-size: 0.875rem;
  }

  .product-price-total {
    font-size: 0.875rem;
    font-weight: bold;
  }

  .product-price-total.contacts-pricing-unit {
    font-size: 2.125rem;
  }

  .product-price-total.contacts-text-unit {
    font-size: 1.125rem;
  }

  .price-description-new {
    color:#676879;
    font-weight: 400;
    font-size: 14px;
    margin-top: 8px;
    font-family: "figtree", sans-serif;
  }
`;
